export default __webpack_public_path__ + "static/uxwriting-85a76a23e854d160f78fb8c339d9c06d.jpg";